import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type ConnectorNodeOptions = {} & SimpleManaNodeOptions

export default class ConnectorNode extends SimpleManaNode {

	static nodeName = "Connection node"
	static nodeDesc = "Most basic node used to transfer mana"
	static nodeIcon = '🔗'
	static category = NodeCategories.Logistics
	static nodeType = 'ConnectorNode'

	constructor(options: ConnectorNodeOptions) {
		super({
			...options,

			size: 20,
		})
	}

	// no scroll behavior
	onScroll(dir: number) { }

	getSymbol() {
		return ''
	}

}